import { createStore, applyMiddleware, compose } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';

import reducer from '@/redux/ducks';
import constants from '@/utils/constants';

import rootPersistConfig from './persistConfig';

const sagaMiddleware = createSagaMiddleware();

// saving state or part of it to local storage on every change to store
const persistedReducer = persistReducer(rootPersistConfig, reducer);

export default function configureStore(initialState) {
	if (constants.BUILD_ENVIRONMENT !== 'production') {
		const composeEnhancers =
			window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
		return createStore(
			persistedReducer,
			initialState,
			composeEnhancers(applyMiddleware(sagaMiddleware)),
		);
	}
	return createStore(
		persistedReducer,
		initialState,
		applyMiddleware(sagaMiddleware),
	);
}

const store = configureStore();
// Creating persisted store for redux-persistence
const persistor = persistStore(store);

export { store, persistor, sagaMiddleware };
